<template>
  <div :class="`bap_portal_overlay-root ${active && 'active'}`">
    <div class="bap_portal_overlay-spinner">
      <i class="fa fa-spinner fa-spin inner-loading"></i>
    </div>
  </div>
</template>


<script>
export default {
  name: "Overlay",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.bap_portal_overlay-root {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
  cursor: pointer;
}

.bap_portal_overlay-root.active {
  display: initial;
}

.bap_portal_overlay-spinner {
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
}
</style>
